var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"title-link px-0 dense-text",attrs:{"to":_vm.linkTo,"title":_vm.video.lang
      ? _vm.video.lang.title
      : _vm.video.common_name
      ? _vm.video.common_name
      : _vm.video.id}},[_c('v-card-title',{staticClass:"pt-0 pb-1 dense-text text-truncate",class:_vm.dense ? 'pt-2' : 'pt-0'},[_vm._v(" "+_vm._s(_vm.video.lang ? _vm.video.lang.title : _vm.video.common_name ? _vm.video.common_name : _vm.video.id)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }